export const SUCCES_ACCEPTATION_MODIFICATION_BANQUE =
  "Modification de la banque accepté avec succès";
export const SUCCES_ACCEPTATION_ANNULATION_BANQUE =
  "Annulation accepté avec succès";
export const SUCCES_ACCEPTATION_CHANGEMENT_BANQUE =
  "Changement de la banque accepté avec succès";
export const SUCCES_ACCEPTATION_DOMICILIATION =
  "Domiciliation accepté avec succès";
export const SUCCES_ACCEPTATION_PRE_DOMICILIATION =
  "Pré-domiciliation accepté avec succès";
export const SUCCES_REFUS_MODIFICATION_BANQUE =
  "Modification de la banque refusé avec succès";
export const SUCCES_REFUS_ANNULATION_BANQUE = "Annulation refusé avec succès";
export const SUCCES_REFUS_CHANGEMENT_BANQUE =
  "Changement de la banque refusé avec succès";
export const SUCCES_REFUS_DOMICILIATION = "Domiciliation refusé avec succès";
export const SUCCES_REFUS_PRE_DOMICILIATION =
  "Pré-domiciliation refusé avec succès";
